module.exports = __webpack_public_path__ + "img/xl_yn.353838fa.png";